export default __webpack_public_path__ + "static/media/icon-application.6e21ae1f.svg";